'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _d = require('d3');

var d3 = _interopRequireWildcard(_d);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactMeasure = require('react-measure');

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GENE_SLOT_HEIGHT = 25;
var GENE_TRANSCRIPT_HEIGHT = 5;
var GENE_TRANSCRIPT_OFFSET = 2;
var GENE_BACKDROP_PADDING = 2;
var GENE_TRACK_PADDING = 5;
var CHAR_HEIGHT = 12;
var HEIGHT_DEFAULT = 400;
var SCALE_FACTOR = 2;
var HIDDEN_TYPE_MAP = {
  gene: 1
};
var HIDDEN_TYPE_MAP_INVERSE = {};
Object.keys(HIDDEN_TYPE_MAP).forEach(function (k) {
  return HIDDEN_TYPE_MAP_INVERSE[HIDDEN_TYPE_MAP[k]] = k;
});

var color = function color(d, noSelectedEntities) {
  return d.selected ? _theme2.default.gecko.colorSelected : !noSelectedEntities && d.chained ? _theme2.default.gecko.colorChained : _theme2.default.gecko.color;
};
var backgroundColor = function backgroundColor(d, noSelectedEntities) {
  return d.selected ? _theme2.default.gecko.backgroundColorSelected : !noSelectedEntities && d.chained ? _theme2.default.gecko.backgroundColorChained : _theme2.default.gecko.backgroundColor;
};

var wrapText = function wrapText(text, maxLineWidth, measure) {
  var lines = [];
  var spaceWidth = measure(' ');
  var wordsLeft = text.split(' ');
  var currentLine = '';
  var currentLineWidth = 0;
  var currentMaxLineWidth = 0;
  while (wordsLeft.length > 0) {
    var word = wordsLeft.shift();
    var wordWidth = measure(word);
    if (currentLineWidth + wordWidth < maxLineWidth) {
      // word fits on current line
      currentLine += (currentLineWidth > 0 ? ' ' : '') + word;
      currentLineWidth += (currentLineWidth > 0 ? spaceWidth : 0) + wordWidth;
      currentMaxLineWidth = currentLineWidth > currentMaxLineWidth ? currentLineWidth : currentMaxLineWidth;
    } else {
      if (wordWidth < maxLineWidth) {
        // word doesn't fit on line, but fits on next
        lines.push(currentLine);
        currentLine = word;
        currentLineWidth = wordWidth;
        currentMaxLineWidth = currentLineWidth > currentMaxLineWidth ? currentLineWidth : currentMaxLineWidth;
      } else {
        // word doesn't fit on a single line
        // TODO: wrap single word
        lines.push(currentLine);
        currentLine = word;
        currentLineWidth = wordWidth;
        currentMaxLineWidth = currentLineWidth > currentMaxLineWidth ? currentLineWidth : currentMaxLineWidth;
      }
    }
    // last word?
    if (wordsLeft.length === 0) {
      lines.push(currentLine);
    }
  }
  return {
    lines: lines,
    width: currentMaxLineWidth
  };
};

var GeneTrack = function (_React$Component) {
  _inherits(GeneTrack, _React$Component);

  function GeneTrack(props) {
    _classCallCheck(this, GeneTrack);

    var _this = _possibleConstructorReturn(this, (GeneTrack.__proto__ || Object.getPrototypeOf(GeneTrack)).call(this, props));

    _this.canvasRef = _react2.default.createRef();
    _this.hiddenCanvasRef = _react2.default.createRef();
    return _this;
  }

  _createClass(GeneTrack, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._render();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._render();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var measureRef = this.props.measureRef;

      var _dimensions2 = this._dimensions(),
          width = _dimensions2.width,
          height = _dimensions2.height;

      return _react2.default.createElement(
        'div',
        {
          ref: measureRef,
          style: {
            width: '100%',
            height: height + 'px',
            position: 'relative'
          }
        },
        _react2.default.createElement('canvas', {
          width: width ? width * SCALE_FACTOR : 0,
          height: height * SCALE_FACTOR,
          style: {
            width: width + 'px',
            height: height + 'px',
            pointerEvents: 'none',
            position: 'absolute',
            top: 0,
            left: 0
          },
          ref: function ref(node) {
            return _this2.canvasRef = node;
          }
        }),
        _react2.default.createElement('canvas', {
          width: width ? width * SCALE_FACTOR : 0,
          height: height * SCALE_FACTOR,
          style: {
            width: width + 'px',
            height: height + 'px',
            position: 'absolute',
            top: 0,
            left: 0,
            imageRendering: 'pixelated',
            opacity: 0
          },
          ref: function ref(node) {
            return _this2.hiddenCanvasRef = node;
          }
        })
      );
    }
  }, {
    key: '_width',
    value: function _width() {
      var contentRect = this.props.contentRect;
      var width = contentRect.bounds.width;

      return width;
    }
  }, {
    key: '_height',
    value: function _height() {
      var contentRect = this.props.contentRect;
      var height = contentRect.bounds.height;

      return height;
    }
  }, {
    key: '_height',
    value: function _height() {
      var _props = this.props,
          data = _props.data,
          start = _props.start,
          end = _props.end;

      var width = this._width();
      if (this._bail(data, width)) {
        return HEIGHT_DEFAULT;
      }
      var scalePosition = d3.scaleLinear().domain([start, end]).range([_theme2.default.margin.left, width - _theme2.default.margin.left - _theme2.default.margin.right]);

      var _geneSlots2 = this._geneSlots(data.genes, scalePosition),
          geneSlots = _geneSlots2.slots;

      var trackConfig = this._trackConfig(geneSlots.length);
      return trackConfig.height;
    }
  }, {
    key: '_dimensions',
    value: function _dimensions() {
      var width = this._width();
      var height = this._height();
      return { width: width, height: height };
    }
  }, {
    key: '_bail',
    value: function _bail(data, width) {
      return !width || !data || !data.genes;
    }
  }, {
    key: '_render',
    value: function _render() {
      var _props2 = this.props,
          rawData = _props2.data,
          start = _props2.start,
          end = _props2.end;

      var _generateHiddenColors2 = this._generateHiddenColors(rawData),
          colorMap = _generateHiddenColors2.colorMap,
          data = _objectWithoutProperties(_generateHiddenColors2, ['colorMap']);

      // const noSelectedEntities = !selectedGenes;


      var noSelectedEntities = true;

      var width = this._width();
      if (this._bail(data, width)) {
        return null;
      }

      var canvas = this.canvasRef;
      var context = canvas.getContext('2d');
      var hiddenCanvas = this.hiddenCanvasRef;
      var hiddenContext = hiddenCanvas.getContext('2d');

      // d3.select(hiddenCanvas).on('mousemove', function() {
      //   const point = d3.mouse(this);
      //   const [r, g, b, a] = hiddenContext.getImageData(
      //     Math.round(point[0]) * SCALE_FACTOR,
      //     Math.round(point[1]) * SCALE_FACTOR,
      //     1,
      //     1
      //   ).data;
      //   const color = `rgb(${r},${g},${b},${a})`;
      //   const item = colorMap[color];
      //   if (item) {
      //     const type = HIDDEN_TYPE_MAP_INVERSE[r >> 4];
      //     d3.select(hiddenCanvas).style('cursor', 'pointer');
      //     handleMousemove(item, type, point);
      //   } else {
      //     d3.select(hiddenCanvas).style('cursor', 'auto');
      //   }
      // });

      // d3.select(hiddenCanvas).on('click', function() {
      //   const point = d3.mouse(this);
      //   const [r, g, b, a] = hiddenContext.getImageData(
      //     Math.round(point[0]) * SCALE_FACTOR,
      //     Math.round(point[1]) * SCALE_FACTOR,
      //     1,
      //     1
      //   ).data;
      //   const color = `rgb(${r},${g},${b},${a})`;
      //   const item = colorMap[color];
      //   if (item) {
      //     const type = HIDDEN_TYPE_MAP_INVERSE[r >> 4];
      //     handleClick(item, type, point);
      //   }
      // });

      var scalePosition = d3.scaleLinear().domain([start, end]).range([_theme2.default.margin.left, width - _theme2.default.margin.left - _theme2.default.margin.right]);

      var _geneSlots3 = this._geneSlots(data.genes, scalePosition),
          geneSlots = _geneSlots3.slots,
          genesWithSlots = _geneSlots3.genesWithSlots;

      var trackConfig = this._trackConfig(geneSlots.length);

      context.save();
      context.imageSmoothingEnabled = true;
      context.scale(SCALE_FACTOR, SCALE_FACTOR);
      context.clearRect(0, 0, width, trackConfig.height);

      hiddenContext.save();
      hiddenContext.scale(SCALE_FACTOR, SCALE_FACTOR);
      hiddenContext.imageSmoothingEnabled = false;
      hiddenContext.webkitImageSmoothingEnabled = false;
      hiddenContext.mozImageSmoothingEnabled = false;
      hiddenContext.msImageSmoothingEnabled = false;
      hiddenContext.oImageSmoothingEnabled = false;
      hiddenContext.clearRect(0, 0, width, trackConfig.height);

      // clip
      context.rect(_theme2.default.margin.left, 0, width - _theme2.default.margin.left - _theme2.default.margin.right, this._height());
      context.clip();

      this._renderGenes(context, hiddenContext, scalePosition, trackConfig.genes, genesWithSlots, noSelectedEntities);

      context.restore();
      hiddenContext.restore();
    }
  }, {
    key: '_renderGenes',
    value: function _renderGenes(context, hiddenContext, scaleX, track, data, noSelectedEntities) {
      context.save();
      context.translate(0, track.top + GENE_TRACK_PADDING);
      hiddenContext.save();
      hiddenContext.translate(0, track.top + GENE_TRACK_PADDING);

      // genes
      data.forEach(function (d) {
        var label = d.start === d.tss ? d.symbol + '>' : '<' + d.symbol;
        var textWidth = context.measureText(label).width;

        var backdropX = scaleX(d.start) - GENE_BACKDROP_PADDING;
        var backdropY = d.slotIndex * GENE_SLOT_HEIGHT + GENE_TRANSCRIPT_OFFSET - GENE_BACKDROP_PADDING;
        var backdropWidth = Math.max(textWidth, scaleX(d.end) - scaleX(d.start)) + GENE_BACKDROP_PADDING * 2;
        var backdropHeight = GENE_TRANSCRIPT_HEIGHT + CHAR_HEIGHT + GENE_BACKDROP_PADDING * 2;
        var spitY = d.slotIndex * GENE_SLOT_HEIGHT + GENE_TRANSCRIPT_OFFSET + GENE_TRANSCRIPT_HEIGHT / 2;

        // picker
        hiddenContext.fillStyle = d.hiddenColor;
        hiddenContext.fillRect(backdropX, backdropY, backdropWidth, backdropHeight);

        // backdrop
        context.fillStyle = backgroundColor(d, noSelectedEntities);
        context.strokeStyle = color(d, noSelectedEntities);
        context.fillRect(backdropX, backdropY, backdropWidth, backdropHeight);
        context.strokeRect(backdropX, backdropY, backdropWidth, backdropHeight);

        // spit
        context.beginPath();
        context.moveTo(scaleX(d.start), spitY);
        context.lineTo(scaleX(d.end), spitY);
        context.stroke();

        // exons
        d.exons.forEach(function (e) {
          var exonX = scaleX(e[[0]]);
          var exonY = d.slotIndex * GENE_SLOT_HEIGHT + GENE_TRANSCRIPT_OFFSET;
          var exonWidth = scaleX(e[[1]]) - exonX;
          var exonHeight = GENE_TRANSCRIPT_HEIGHT;
          context.fillRect(exonX, exonY, exonWidth, exonHeight);
          context.strokeRect(exonX, exonY, exonWidth, exonHeight);
        });

        // label
        var labelX = scaleX(d.start);
        var labelY = d.slotIndex * GENE_SLOT_HEIGHT + GENE_TRANSCRIPT_OFFSET * 2 + GENE_TRANSCRIPT_HEIGHT;
        context.textBaseline = 'hanging';
        context.fillStyle = color(d, noSelectedEntities);
        context.fillText(label, labelX, labelY);
      });

      context.restore();
      hiddenContext.restore();
    }
  }, {
    key: '_generateHiddenColors',
    value: function _generateHiddenColors(data) {
      var _this3 = this;

      var genes = data.genes;

      var colorMap = {};
      var genesWithHiddenColor = genes.map(function (d, i) {
        var color = _this3._hiddenColor(i, 'gene');
        colorMap[color] = d;
        return _extends({}, d, { hiddenColor: color });
      });

      return {
        colorMap: colorMap,
        genes: genesWithHiddenColor
      };
    }
  }, {
    key: '_hiddenColor',
    value: function _hiddenColor(entityId, type) {
      var typeId = HIDDEN_TYPE_MAP[type];
      var r = (typeId << 4) + Math.floor(entityId / 65536) % 256;
      var g = Math.floor(entityId / 256) % 256;
      var b = entityId % 256;
      return 'rgb(' + r + ',' + g + ',' + b + ',255)';
    }
  }, {
    key: '_geneSlots',
    value: function _geneSlots(genes, scale) {
      var sortedGenes = _lodash2.default.sortBy(genes.slice(), function (d) {
        return d.start;
      });
      var canvas = this.canvasRef;
      var context = canvas.getContext('2d');

      var slotCount = 0;
      var slots = [];
      var genesWithSlots = [];
      var endOfGene = function endOfGene(gene) {
        var transcriptLength = scale(gene.end) - scale(gene.start);
        var labelLength = context.measureText(gene.symbol + '>').width;
        return transcriptLength > labelLength ? scale.invert(scale(gene.end) + GENE_BACKDROP_PADDING * 3) : scale.invert(scale(gene.start) + labelLength + GENE_BACKDROP_PADDING * 3);
      };
      sortedGenes.forEach(function (gene) {
        var sortedSlots = _lodash2.default.sortBy(slots, function (d) {
          return d.index;
        });
        var suitableSlots = sortedSlots.filter(function (slot) {
          return gene.start > slot.end;
        });
        if (suitableSlots.length > 0) {
          // store in slots
          suitableSlots[0].genes.push(gene);

          // update slot end
          suitableSlots[0].end = endOfGene(gene);

          // store in gene list with slot index
          genesWithSlots.push(_extends({}, gene, { slotIndex: suitableSlots[0].index }));
        } else {
          // store in slots
          var newSlot = {
            genes: [gene],
            end: endOfGene(gene),
            index: slotCount++
          };
          slots.push(newSlot);

          // store in gene list with slot index
          genesWithSlots.push(_extends({}, gene, { slotIndex: newSlot.index }));
        }
      });

      return { slots: slots, genesWithSlots: genesWithSlots };
    }
  }, {
    key: '_trackConfig',
    value: function _trackConfig(geneSlotCount) {
      var geneTrackHeight = geneSlotCount * GENE_SLOT_HEIGHT + 2 * GENE_TRACK_PADDING;
      var genes = {
        top: 0,
        bottom: geneTrackHeight,
        height: geneTrackHeight
      };
      return {
        genes: genes,
        height: genes.bottom
      };
    }
  }, {
    key: '_wrapText',
    value: function _wrapText(context, text, maxWidth) {
      var textStyle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '10px sans-serif';

      if (textStyle) {
        context.font = textStyle;
      }

      var _wrapText2 = wrapText(text, maxWidth, function (str) {
        return context.measureText(str).width;
      }),
          lines = _wrapText2.lines,
          width = _wrapText2.width;

      return { lineArray: lines, width: width };
    }
  }]);

  return GeneTrack;
}(_react2.default.Component);

exports.default = (0, _reactMeasure.withContentRect)('bounds')(GeneTrack);